import { render, staticRenderFns } from "./AccountSendLogPos.vue?vue&type=template&id=600c7077"
import script from "./AccountSendLogPos.vue?vue&type=script&lang=js"
export * from "./AccountSendLogPos.vue?vue&type=script&lang=js"
import style0 from "./AccountSendLogPos.vue?vue&type=style&index=0&id=600c7077&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports